module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/subcategories/haircut-3a941e687ff123244f1069f7aabeeb74.png";